const getEventTypeName = (eventType, eventTypes) => {
  if (
    eventType &&
    eventTypes[eventType.eventType] &&
    eventTypes[eventType.eventType].sub[eventType.sub]
  ) {
    return eventTypes[eventType.eventType].sub[eventType.sub].name
  }
  return ''
}

export default getEventTypeName
